import { render, staticRenderFns } from "./Scheme2.vue?vue&type=template&id=24c26120&scoped=true"
import script from "./Scheme2.vue?vue&type=script&lang=js"
export * from "./Scheme2.vue?vue&type=script&lang=js"
import style0 from "./Scheme2.vue?vue&type=style&index=0&id=24c26120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c26120",
  null
  
)

export default component.exports